// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SupportPage {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  text-align: center;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.SupportPage .pageTitle {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 32px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.SupportPage h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #111827;
}

.SupportPage p {
  font-size: 18px;
  line-height: 1.6;
  color: #4b5563;
  max-width: 600px;
  margin: 0 auto 40px;
}

.support-email-box {
  background-color: #f3f4f6;
  padding: 24px;
  border-radius: 12px;
  display: inline-block;
}

.support-email-box h2 {
  margin: 0;
  color: #2563eb;
  font-size: 20px;
}

@media (max-width: 480px) {
  .SupportPage {
    padding: 24px 16px;
  }

  .SupportPage .pageTitle {
    font-size: 28px;
  }

  .SupportPage p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Support.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wIAAwI;EACxI,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".SupportPage {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 40px 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  text-align: center;\n  min-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.SupportPage .pageTitle {\n  font-size: 36px;\n  font-weight: 800;\n  margin-bottom: 32px;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.SupportPage h2 {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: #111827;\n}\n\n.SupportPage p {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #4b5563;\n  max-width: 600px;\n  margin: 0 auto 40px;\n}\n\n.support-email-box {\n  background-color: #f3f4f6;\n  padding: 24px;\n  border-radius: 12px;\n  display: inline-block;\n}\n\n.support-email-box h2 {\n  margin: 0;\n  color: #2563eb;\n  font-size: 20px;\n}\n\n@media (max-width: 480px) {\n  .SupportPage {\n    padding: 24px 16px;\n  }\n\n  .SupportPage .pageTitle {\n    font-size: 28px;\n  }\n\n  .SupportPage p {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
